import axios from 'axios'
import BaseModel from '@/models/BaseModel.js'

export default class SubRekening extends BaseModel {
  fields =  {
    'code': {
      label: 'Kode Rekening',
      type: 'text',
      rules: 'required'
    },
    'name': {
      label: 'Objek Kegiatan',
      type: 'text',
      rules: 'required'
    },
    'budget': {
      label: 'Budget',
      type: 'price',
      rules: ''
    },
    'parent_id': {
      type: 'enum',
      label: 'parent_id',
      rules: 'required',
      options: []
    },
  }

  endpoint = process.env.VUE_APP_API_URL + 'account-codes'
}